import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { DataExtractionService } from '@/infra/services/data-extraction';

interface CreateDataExtractionParams {
	organization_id: string;
	company_id?: string;
	sector_id?: string | null;
	line_id?: string | null;
	workstation_id?: string | null;
	extraction_name?: string;
	start_date?: string | null;
	end_date?: string | null;
	extraction_type?: string;
	data_extraction_files?: string[];
	select_all_files?: boolean;
	excluded_files?: string[];
	file_name?: string;
}

const Service = DataExtractionService.getInstance();

export const useCreateDataExtraction = () => {
	return useMutation({
		mutationFn: async (params: CreateDataExtractionParams) => Service.create(params),
		onSuccess: () => {
			message.success(I18n.get('Data extraction created successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error creating data extraction'));
		}
	});
};
